import { Box } from "@mui/material";

interface Props {
  icon: React.ReactElement;
  title: string[];
  content: string;
  color?: string;
  background?: string;
}

const ThematicDataCard: React.FC<Props> = ({
  icon,
  title,
  content,
  color = "#fff",
  background = "#fff",
}) => {
  return (
    <Box
      sx={{
        borderTop: `1px solid ${color}`,
        padding: { xs: "0 1.5rem", md: "0 1.5rem 2rem" },
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          paddingTop: "1.5rem",
          paddingBottom: "0.5rem",
          background,
          backgroundClip: "text",
          WebkitTextFillColor: "transparent",
          color,
        }}
      >
        <Box sx={{ marginRight: "1rem", display: { xs: "none", md: "block" } }}>
          {icon}
        </Box>
        <Box sx={{ fontSize: 25, lineHeight: 1.2, fontWeight: 600 }}>
          {title.map((str, idx) => (
            <Box key={str + idx}>{str}</Box>
          ))}
        </Box>
      </Box>
      <Box sx={{ fontSize: 18, lineHeight: 1.2, paddingRight: 6 }}>
        {content}
      </Box>
    </Box>
  );
};

export default ThematicDataCard;
